import { Children } from "react"
import { Box, Typography, useMediaQuery } from "@mui/material"
import { Trans } from "react-i18next"
import { theme } from "../../../utils/theme/godzilla_light"
import { EDUCATION_HUB_CONTENT_MAX_WIDTH } from "../constants"
import ImageListData from '../../../assets/data/educationHub/imagingData'

const styles = {
    cardDivider: {
        ...theme.components.shadowCard,
        height: "auto",
        width: "0.7px",
        backgroundColor: "rgba(37, 37, 37, 0.12)",
    },
    itemBoxWrapper: {
        ...theme.components.shadowCard,
        mt: "16px",
        backgroundColor: "#fff",
        pt: "23px",
        px: "12px"
    },
    itemTitle: {
        ...theme.typography.poppinsBodyBold,
        fontSize: "14.71px",
        color: "#1E1E22",
        maxWidth: "200px"
    },
    intermediateLabel: {
        ...theme.typography.components.sectionDescription,
        fontSize: "11.93px",
        color: "#393939"
    },
    imageDescLabel: {
        ...theme.typography.components.sectionDescription,
        fontSize: "9px",
        fontStyle: "italic",
        color: "#393939"
    },
    rowBoxContainer: {
        flex: 1,
        pb: "25px"
    }
}
const ProgressionImageList = () => {
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))
    const imageItems = ImageListData.imageListData

    return (
        <Box sx={{ backgroundColor: "#f8f8f8f8", pt: "40px", pb: "48px" }} display={"flex"} flexDirection={"column"} alignItems={"center"} textAlign={"left"} px={"31px"}>
            <Box maxWidth={EDUCATION_HUB_CONTENT_MAX_WIDTH} width="100%">
                {Children.toArray(imageItems.map((item: any) => {
                    return (
                        <Box sx={styles.itemBoxWrapper}>
                            <Typography sx={styles.itemTitle}>
                                {item.title}
                            </Typography>
                            <Box display={"flex"} gap={"12px"} sx={{ mt: "1rem" }} flexWrap={"wrap"}>
                                <Box sx={styles.rowBoxContainer}>
                                    <Typography sx={styles.intermediateLabel}>
                                        Intermediate AMD
                                    </Typography>
                                    <img src={item.intermediateImageUrl} alt="intermediate-amd" style={{ marginTop: "15px", maxWidth: isMobileX ? "300px" : "250px" }} />
                                    <Typography sx={styles.imageDescLabel}>
                                        {item.intermediateImageDesc}
                                    </Typography>
                                </Box>
                                <Box sx={styles.cardDivider} />
                                <Box sx={styles.rowBoxContainer}>
                                    <Typography sx={styles.intermediateLabel}>
                                        Advanced AMD (Geographic Atrophy)
                                    </Typography>
                                    <img src={item.advancedImageUrl} alt="advanced-amd" style={{ marginTop: "15px", maxWidth: isMobileX ? "300px" : "250px" }} />
                                    <Typography sx={styles.imageDescLabel}>
                                        {item.advancedImageDesc}
                                    </Typography>
                                </Box>
                                <Box sx={styles.cardDivider} />
                                <Box sx={styles.rowBoxContainer}>
                                    <Typography sx={{ ...styles.intermediateLabel, fontWeight: 700 }}>
                                        <Trans
                                            i18nKey={item.featuresTitle}
                                            components={{ sup: <sup /> }}
                                        />
                                    </Typography>
                                    <ul style={{ marginTop: "31px", paddingLeft: "12px" }}>
                                        {item.features.map((element: any) => {
                                            return (
                                                <li style={{ ...styles.intermediateLabel, fontSize: "12.24px" }}>{element}</li>
                                            )
                                        })}
                                    </ul>
                                    <Typography sx={{ ...styles.imageDescLabel, mt: "31px" }}>
                                        {item.feauturesCourtsey}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    )
                }))}
            </Box>
        </Box>
    )
}

export default ProgressionImageList